export const ADMIN_API_URL = `https://us-central1-allsports-69231.cloudfunctions.net/admins`;
export const API_URL = `https://us-central1-allsports-69231.cloudfunctions.net`;
